import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import { H2, H6 } from '@components/Text'

export const Wrapper = styled.section`
  padding-top: 72px;
  padding-bottom: 72px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-top: 96px;
    padding-bottom: 96px;
  }
`

export const TitleWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`

export const Title = styled(H2)`
  font-weight: 900;
  line-height: 37px;
  color: var(--primary-text);
  width: 265px;

  span {
    color: var(--sao-paulo-60);
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    line-height: 48px;
    width: auto;
  }
`

export const Icon = styled.img(
  ({ isOpen }) => `
  height: 32px;
  transition: transform .5s;
  transform: ${isOpen ? 'rotate(-135deg)' : `rotate(0deg)`}
`
)

export const QuestionsWrapper = styled.section`
  margin-top: 56px;
`

export const QuestionDescription = styled(H6)`
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    max-width: 880px;
  }
`
